import type { MarkerClusterer } from '@googlemaps/markerclusterer';

export const mapPromiseKey = Symbol('map') as InjectionKey<
	Promise<google.maps.Map>
>;

export const markerKey = Symbol('marker') as InjectionKey<
	Ref<google.maps.marker.AdvancedMarkerElement | undefined>
>;

export const clusterKey = Symbol('cluster') as InjectionKey<
	Ref<MarkerClusterer | undefined>
>;
